import {inject, isDevMode, NgModule, provideAppInitializer,} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SharedModule} from './shared/shared.module';
import {StoreModule} from '@ngrx/store';
import {metaReducers, reducers} from './store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {effects} from './store/effects';
import {EffectsModule} from '@ngrx/effects';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi,} from '@angular/common/http';
import {AuthInterceptor} from './guards/auth-interceptor';
import {ErrorInterceptor} from './guards/error.interceptor';
import {GraphQLModule} from './graphql.module';
import {NgxPermissionsModule, NgxPermissionsService} from 'ngx-permissions';
import {PageComponent} from './page/page.component';
import {CONFIGURATION_TOKEN} from './app.tokens';
import {provideNgxMask} from 'ngx-mask';
import {DatePipe, DecimalPipe} from '@angular/common';
import {LoadingBarHttpClientModule} from '@ngx-loading-bar/http-client';
import {LoadingBarModule} from '@ngx-loading-bar/core';
import {ForgotPasswordComponent} from './guest/forgot-password/forgot-password.component';
import {CheckYourEmailComponent} from './guest/check-your-email/check-your-email.component';
import {ResetPasswordComponent} from './guest/reset-password/reset-password.component';
import {SetPasswordComponent} from './guest/set-password/set-password.component';
import {FormsModule} from '@angular/forms';
import {ChangePasswordComponent} from './guest/change-password/change-password.component';
import {AuthService} from './services/auth.service';
import {WavyBackgroundComponent} from './guest/wavy-background/wavy-background.component';
import {SystemFooterComponent} from './guest/system-footer/system-footer.component';
import {GuestMainComponent} from './guest/guest-main-copy/guest-main.component';
import {LoginComponent} from './guest/login/login.component';
import {QRCodeComponent} from "angularx-qrcode";

@NgModule({
  declarations: [
    AppComponent,
    PageComponent,
    LoginComponent,
    ForgotPasswordComponent,
    CheckYourEmailComponent,
    ResetPasswordComponent,
    SetPasswordComponent,
    ChangePasswordComponent,
    // GuestMainComponent,
    GuestMainComponent,
    WavyBackgroundComponent,
    SystemFooterComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LoadingBarHttpClientModule,
    LoadingBarModule,
    SharedModule,
    QRCodeComponent,
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateSerializability: false,
        strictActionSerializability: false,
        strictStateImmutability: true,
        strictActionImmutability: true,
        strictActionWithinNgZone: true,
        strictActionTypeUniqueness: true,
      },
    }),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: !isDevMode(),
      autoPause: true,
      trace: false,
      traceLimit: 75,
    }),
    EffectsModule.forRoot(effects),
    GraphQLModule,
    NgxPermissionsModule.forRoot(),
    FormsModule,
  ],
  providers: [
    DatePipe,
    DecimalPipe,
    provideNgxMask(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: CONFIGURATION_TOKEN,
      useValue:
        'to be used later for translation storage and use translation on components',
      multi: true,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    NgxPermissionsService,
    provideAppInitializer(async () => {
      const authService = inject(AuthService);
      await authService.loadUserSession();
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
